import uuidv1 from 'uuid/v1';

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const POPUP_SHOW_NOTIFICATION = 'POPUP_SHOW_NOTIFICATION';
export const POPUP_HIDE_NOTIFICATION = 'POPUP_HIDE_NOTIFICATION';
export const NOTIFICATION_TYPES = {
    INFO: 'info',
    ERROR: 'warning'
};

export const showNotification = (
  message,
  type = NOTIFICATION_TYPES.INFO,
  category
) => ({
  type: SHOW_NOTIFICATION,
  newNotification: {
      message,
      type: type,
      key: uuidv1(),
      category: category
  },
});

export const hideNotification = (notificationKey) => ({
  type: HIDE_NOTIFICATION,
  notificationKey,
});

export const popupShowNotification = (
  message,
  type = NOTIFICATION_TYPES.INFO,
) => ({
  type: POPUP_SHOW_NOTIFICATION,
  newNotification: {
    message,
    type: type,
    key: uuidv1(),
  },
});

export const popupHideNotification = (notificationKey) => ({
  type: POPUP_HIDE_NOTIFICATION,
  notificationKey,
});